(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wkt-premium-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.wktStaticCartUpsellReady) return;
    window.wktStaticCartUpsellReady = true;

    const refreshVariantPresentation = (selector) => {
      const card = selector.closest('.upsell-product');
      const option = selector.options[selector.selectedIndex];
      if (!card || !option) return;

      const image = card.querySelector('.upsell-product-image');
      const price = card.querySelector('[data-wkt-upsell-price]');
      const compare = card.querySelector('[data-wkt-upsell-compare]');
      const button = card.querySelector('.upsell-add-button');

      if (image && option.dataset.imageUrl) image.src = option.dataset.imageUrl;
      if (button) button.dataset.productId = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.hidden = option.dataset.onSale !== 'true';
        const compareText = compare.querySelector('s');
        if (compareText) compareText.textContent = option.dataset.compareAt || '';
      }
    };

    const initialize = () => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      // Use the Liquid-rendered cart upsell immediately.
      // No cart.js + recommendations API round trip is needed to make it visible.
      drawer.initializeUpsellButtons?.();
      drawer.initializeVariantSelectors?.();

      drawer.addEventListener('change', (event) => {
        const selector = event.target.closest('.upsell-product__variant-selector');
        if (selector) refreshVariantPresentation(selector);
      });

      drawer.addEventListener('cartUpdated', () => {
        requestAnimationFrame(() => {
          drawer.initializeUpsellButtons?.();
          drawer.initializeVariantSelectors?.();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
